import FormNotConnected from './FormNotConnected';

export default FormNotConnected;



// WEBPACK FOOTER //
// ./src/components/Login/FormNotConnected/index.js